// store/index.js
import { createStore } from 'vuex';
import { main } from './main';
import { constants } from './constants';

const store = createStore({
    state: {
        ...main.state,
        ...constants.state,
    },
    mutations: {
        ...main.mutations,
    },
    actions: {
        ...main.actions,
    },
    getters: {
        ...main.getters,
        ...constants.getters,
    }
});

export default store;
